export default {
  newPasswordLabel: 'Nueva Contraseña',
  verificationCodeLabel: 'Código de verificación',
  confirmPasswordLabel: 'Confirmar Nueva Contraseña',
  verificationCodeRegexValidationError: 'El código debe de ser de 6 dígitos.',
  message: 'Para estar seguros de que eres tú, por favor escribe el código que enviamos a tu correo.',
  codeErrorMessage: 'Código inválido, ingresa el código correcto nuevamente o solicita uno nuevo.',
  codeExpiredMessage: 'Código inválido, solicita uno nuevo.',
  limitErrorMessage: 'Se ha excedido el límite de intentos, intente después de un tiempo.',
  errorDefault: 'Ups, ha ocurrido un error.',
  submit: 'Reestablecer contraseña',
};
